"use strict";
const pluginVersion = "13.0.0-pre";
const defaultOptions = {
  showImage: true
};

export { defaultOptions, pluginVersion };
